import { api } from './client';
import type { LeaderboardResponse, ScoreRow, ScorecardData } from './types';

export const scoresApi = {
  put: (
    eventId: string,
    input: { holeNumber: number; strokes: number; teamId?: string; participantId?: string },
  ) => api.put<{ score: ScoreRow }>(`/events/${eventId}/scores`, input),

  list: (eventId: string) =>
    api.get<{ scores: ScoreRow[] }>(`/events/${eventId}/scores`),

  leaderboard: (eventId: string) =>
    api.get<LeaderboardResponse>(`/events/${eventId}/leaderboard`),

  scorecard: (eventId: string, subjectId: string) =>
    api.get<{ card: ScorecardData }>(`/events/${eventId}/scorecard/${subjectId}`),

  submit: (eventId: string) =>
    api.post<{ subjectKind: 'team' | 'participant'; subjectId: string; submittedAt: string }>(
      `/events/${eventId}/scorecard/submit`,
    ),

  unlock: (eventId: string, subject: { teamId?: string; participantId?: string }) =>
    api.post<{ subjectKind: 'team' | 'participant'; subjectId: string; submittedAt: null }>(
      `/events/${eventId}/scorecard/unlock`,
      subject,
    ),
};
